//Utility
var React = require('react');
var Formatter = require('../../utils/Formatter.js');
var _ = require('lodash');
//Actions
var InSpecieTransferActions = require('../../actions/InSpecieTransferActions.js');
var ApplicationActions = require('../../actions/ApplicationActions.js');
//Store
var InSpecieTransferStore = require('../../stores/InSpecieTransferStore.js').default;
//Components
var SectionHeader = require('../Common/SectionHeader.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var UserNotification = require('../Common/UserNotification.jsx');
//constants
var ApplicationConstants = require('../../constants/ApplicationConstants.js');

function getStateFromStores() {
    return {
        inSpecieAccounts: InSpecieTransferStore.getInSpecieAccounts(),
        inSpecieModel: InSpecieTransferStore.getInSpecieModel(),
        externalFundsExist: InSpecieTransferStore.getIsThereExternalFunds(),
        inlineErrors: InSpecieTransferStore.getInlineErrors(),
        inSpecieDecisions: InSpecieTransferStore.getInSpecieDecisions(),
        crossSectionDependencyMsg: InSpecieTransferStore.getCrossSectionDependencyMsg(),
        isUserNotificationClosed: false
    };
}

var InSpecieTransferSection = React.createClass({
    getInitialState: function () {
        return getStateFromStores();
    },

    componentDidMount: function () {
        InSpecieTransferStore.addChangeListener(this._onChange);
    },

    componentWillUnmount: function () {
        InSpecieTransferStore.removeChangeListener(this._onChange);
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    componentWillUpdate: function (nextProps, nextState) {
        if (nextState.inSpecieDecisions !== this.state.inSpecieDecisions) {
            ApplicationActions.sendInSpecieDecisions(nextState.inSpecieDecisions);
        }
        
        if (!_.isEqual(nextState.inSpecieAccounts, this.state.inSpecieAccounts) ||
            !_.isEqual(nextState.inSpecieModel, this.state.inSpecieModel)) {
            ApplicationActions.sendInSpecieData({ inSpecieAccounts: nextState.inSpecieAccounts, inSpecieModel: nextState.inSpecieModel });
        }
    },

    handleChange: function (event) {
        var fieldId = event.target.model;
        var fieldValue = event.target.value;
        InSpecieTransferActions.updateInSpecieModel(fieldId, fieldValue);
    },

    getCrossSectionMsg: function () {
        var crossSectionMsg = Formatter.formatString(this.props.content.crossSectionParentText, { parentSection: this.props.content.inSpecieTransfer.sectionHeader, sections: _.pluck(this.state.crossSectionDependencyMsg, 'content').join(', ') });

        return crossSectionMsg;
    },

    toggleUserNotificationClose: function () {
        this.setState({ isUserNotificationClosed: true, crossSectionDependencyMsg: this.state.crossSectionDependencyMsg.splice(0, this.state.crossSectionDependencyMsg.length) });
    },

    render: function () {
        var inSpecieAccountListRow = function (item,index) {
            var id = 'istAccount-' + index;
            var trKey = 'tr-' + id;
            var nameKey = 'name-' + id;
            var codeKey = 'code-' + id;
            return <tr key={trKey}>
                        <td className="form-select table-vote">
                            <span key={nameKey }>{item.rollOverName}</span>
                        </td>
                        <td className="table-ref table-vote value" key={codeKey}>{item.accountNumber}</td>
                    </tr>
        }.bind(this);

        var inSpecieAccountRows = this.state.inSpecieAccounts.map(function (item, index) {
            return inSpecieAccountListRow(item, index);
        });

        var externalAccountQuestionContextMessage = '';
        if (this.state.inSpecieModel.externalAccountQuestion === ApplicationConstants.YesNoValues.YES) {
            externalAccountQuestionContextMessage = this.props.content.inSpecieTransfer.externalAccountYesText;
        } else if (this.state.inSpecieModel.externalAccountQuestion === ApplicationConstants.YesNoValues.NO) {
            externalAccountQuestionContextMessage = this.props.content.inSpecieTransfer.externalAccountNoText;
        }

        var noContextualMessage = this.state.inSpecieModel.setUp === ApplicationConstants.YesNoValues.NO
                                ? this.props.content.inSpecieTransfer.noContextualMessage
                                : null;

        return (
            <div>
                {this.state.inSpecieAccounts.length <= 0 ? null :
                (<div id="inSpecieTransferSection" className="in-specie-transfer-section">
                    <SectionHeader sectionName={this.props.content.inSpecieTransfer.sectionHeader}
                                   sectionHelpText={this.props.content.common.sectionHeaderHelp}
                                   NeedHelpInfo={this.props.content.inSpecieTransfer.sectionHelp}
                                   focus={this.props.focus} />
                    <div className="container">
                        <UserNotification id="inSpecieTransferUserNotification"
                                          message={this.getCrossSectionMsg()}
                                          onClick={this.toggleUserNotificationClose}
                                          isHidden={!this.state.crossSectionDependencyMsg.length || this.state.isUserNotificationClosed} />
                        <div id="inSpecieTransferSetup">
                            <RadioInput id="istOption"
                                        value={this.state.inSpecieModel.setUp}
                                        model="setUp"
                                        onChange={this.handleChange}
                                        contextualMessage={noContextualMessage}
                                        data={ApplicationConstants.YesNoRadioData}
                                        label="Would you like to set up an in specie transfer (from eligible FirstChoice products)?" />
                        </div>
                        {this.state.inSpecieModel.setUp === ApplicationConstants.YesNoValues.YES ?
                            (<div className="form-section" id="istAccountList">
                            <div className="form-label-section">
                                <label>Your eligible internal account(s) below will be transferred on an in specie or 'like for like' basis.</label>
                            </div>
                            <table className="table table-single radio-button-list" id="table-allocations">
                                <thead>
                                    <tr>
                                        <td className="column-heading ist-product-header">Product name</td>
                                        <td className="column-heading ist-number-header">Account number</td>
                                    </tr>
                                </thead>
                                <tbody>{inSpecieAccountRows}</tbody>
                            </table>
                            </div>) : null
                        }
                        {this.state.inSpecieModel.setUp === ApplicationConstants.YesNoValues.YES && this.state.externalFundsExist === true ?
                            (<div id="inSpecieTransferExternalFundsAllocation">
                            <RadioInput id="istExternalAccountsQuestion"
                                        model="externalAccountQuestion"
                                        onChange={this.handleChange}
                                        errorList={this.state.inlineErrors}
                                        contextualMessage={externalAccountQuestionContextMessage}
                                        value={this.state.inSpecieModel.externalAccountQuestion}
                                        data={ApplicationConstants.YesNoRadioData}
                                        label="Would you like your external funds to be invested as per the allocation of these accounts shown above?"
                                        helpText={this.props.content.inSpecieTransfer.externalAccountQuestionHelp} />
                            </div>) : null
                        }
                    </div>
                </div>)}
            </div>
        );
    }
});

module.exports = InSpecieTransferSection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/InSpecieTransfer/InSpecieTransferSection.jsx